export default __webpack_public_path__ + "static/media/git.b84e9605.svg";